<template>
    <div>
        <div
            :id="`carouselExampleControls-${item.id}`"
            class="carousel slide"
            data-ride="carousel"
        >
            <div class="carousel-inner">
                <div
                    class="carousel-item"
                    v-for="(i, index) in slides"
                    :key="index"
                    :class="{ active: index == 0 }"
                >
                    <img
                        class="d-block w-100 preview__image_slider"
                        :src="i.image_url"
                        alt=""
                    />
                </div>
            </div>
            <a
                class="carousel-control-prev"
                :href="`#carouselExampleControls-${item.id}`"
                role="button"
                data-slide="prev"
            >
                <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Previous</span>
            </a>
            <a
                class="carousel-control-next"
                :href="`#carouselExampleControls-${item.id}`"
                role="button"
                data-slide="next"
            >
                <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: ["item", "slides"],
    data() {
        return {};
    }
};
</script>
